/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { DeckDto } from '../models/deck-dto';

/**
 * Deck Controller
 */
@Injectable({
  providedIn: 'root',
})
class DeckControllerService extends __BaseService {
  static readonly getDecksUsingGETPath = '/api/decks/';
  static readonly updateDeckUsingPUTPath = '/api/decks/';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * getDecks
   * @param userId userId
   * @return OK
   */
  getDecksUsingGETResponse(userId?: number): __Observable<__StrictHttpResponse<Array<DeckDto>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (userId != null) __params = __params.set('userId', userId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/decks/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DeckDto>>;
      })
    );
  }
  /**
   * getDecks
   * @param userId userId
   * @return OK
   */
  getDecksUsingGET(userId?: number): __Observable<Array<DeckDto>> {
    return this.getDecksUsingGETResponse(userId).pipe(
      __map(_r => _r.body as Array<DeckDto>)
    );
  }

  /**
   * updateDeck
   * @param params The `DeckControllerService.UpdateDeckUsingPUTParams` containing the following parameters:
   *
   * - `name`: name
   *
   * - `deckId`: deckId
   */
  updateDeckUsingPUTResponse(params: DeckControllerService.UpdateDeckUsingPUTParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.name != null) __params = __params.set('name', params.name.toString());
    if (params.deckId != null) __params = __params.set('deckId', params.deckId.toString());
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/decks/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * updateDeck
   * @param params The `DeckControllerService.UpdateDeckUsingPUTParams` containing the following parameters:
   *
   * - `name`: name
   *
   * - `deckId`: deckId
   */
  updateDeckUsingPUT(params: DeckControllerService.UpdateDeckUsingPUTParams): __Observable<null> {
    return this.updateDeckUsingPUTResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module DeckControllerService {

  /**
   * Parameters for updateDeckUsingPUT
   */
  export interface UpdateDeckUsingPUTParams {

    /**
     * name
     */
    name?: string;

    /**
     * deckId
     */
    deckId?: number;
  }
}

export { DeckControllerService }
